import { useContext, useState } from "react";
import { useCallback } from "react";
import { HimmaContext } from "../Context/HimmaContext";
import {
  AddOrUpdateChoiceGroupRequestSchema,
  DeleteSubAdminsRequest,
  ToggleSubAdminStatusRequest,
} from "../client-sdk/api";

const userData = JSON.parse(localStorage.getItem('userData') || '{}');
const localStorageStoreId = userData?.userId



export const useChoiceGroupApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createChoiceGroup = useCallback(
    async (choiceGroup: AddOrUpdateChoiceGroupRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        // const headers = {
        // 'Authorization': `Bearer ${token}`,
        // 'Content-Type': 'application/json',
        // 'userId': userId,
        // }
        // const headers = getAuthHeaders();
        const response = await api.addChoiceGroup(choiceGroup);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const getAllChoiceGroup =
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.getAllChoiceGroups(
          query.page,
          query.limit,
          query.sortBy,
          query.sortOrder,
          query.merchantId,
          undefined,
          undefined,
          query.search
        );
        setLoading(false);
        if (response.status !== 200) {
          setError("Failed to fetch choice groups");
          throw new Error("Failed to fetch choice groups");
        }
        return response.data;
      } catch (err) {
        setLoading(false);
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    }


  const getToggleStatus = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const toggleSubAdminStatusRequest: ToggleSubAdminStatusRequest = {
          ids: Array.isArray(query.id) ? query.id : [query.id],
          status: query.status,
        };
        const response = await api.toggleChoiceGroupStatus(
          toggleSubAdminStatusRequest, localStorageStoreId
        );
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const deleteChoiceGroup = useCallback(
    async (query: any) => {
      setLoading(true);
      setError(null);
      try {
        const deleteSubAdmins: DeleteSubAdminsRequest = {
          ids: query,
        };
        const response = await api.deleteChoiceGroups(deleteSubAdmins, localStorageStoreId);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  const editChoiceGroup = useCallback(
    async (id: any, subAdminData: AddOrUpdateChoiceGroupRequestSchema) => {
      setLoading(true);
      setError(null);
      try {
        const response = await api.editChoiceGroup(id, subAdminData);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : "An error occurred");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );
  return {
    createChoiceGroup,
    getAllChoiceGroup,
    loading,
    error,
    getToggleStatus,
    deleteChoiceGroup,
    editChoiceGroup,
  };
};
